import React, {Fragment} from 'react'

const WaveformScrubber = (props) =>{
  const {
    scrubberPos,
    scrubberSelectPos
  } = props
  return (
    <Fragment>
      <div className="waveform-scrubber" style={{left:`${scrubberPos}%`}}></div>
    </Fragment>
  )
}

export default WaveformScrubber


// WEBPACK FOOTER //
// ./src/components/waveform/WaveformScrubber.js